import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer>
      <p className="company-name">&copy; {currentYear} QUEEN CENTER.</p>
      <div className="socket">
        <a href="https://faktor22.nl" target="_blank" rel="referrer noreferrer">
          <p className="copyright">By Faktor 22 | v 0.1</p>
        </a>
        <button className="scroll-top-btn" onClick={scrollToTop}>
          <img src="/images/icon_scroll_up.svg" alt="Scroll Up" />
        </button>
      </div>
    </footer>
  );
};

export default Footer;
